//imports
import {
    MANUFACTURERS_REFRESH_FIRMWARE_OPEN_MODAL,
    MANUFACTURERS_REFRESH_FIRMWARE_REQUEST,
    MANUFACTURERS_REFRESH_FIRMWARE_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

//initial values
const INIT_STATE = {
    openModal: false,
    loading: false,
    result: null,
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case MANUFACTURERS_REFRESH_FIRMWARE_OPEN_MODAL:
            return { ...state, openModal: true }

        case MANUFACTURERS_REFRESH_FIRMWARE_REQUEST:
            return { ...state, loading: true }

        case MANUFACTURERS_REFRESH_FIRMWARE_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "MANUFACTURER_REFRESH_FIRMWARE"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};
